/**
 * Only the newest load may commit. Starting a load aborts the previous one; `current()` is false once a newer
 * load started or the page moved on (workspace change, unmount), so a slow older response is ignored.
 */
export function createLatestLoader() {
  let generation = 0;
  let controller: AbortController | undefined;
  return {
    begin() {
      controller?.abort();
      controller = new AbortController();
      const mine = ++generation;
      return { signal: controller.signal, current: () => mine === generation };
    },
    cancel() {
      controller?.abort();
      generation += 1;
    },
  };
}

/** Follows next_cursor until it ends or `maxPages` is reached; `complete` is false when more remain. */
export async function collectPages<T>(
  fetchPage: (cursor: string | undefined) => Promise<{ items: T[]; next_cursor?: string | undefined }>,
  maxPages: number,
): Promise<{ items: T[]; complete: boolean }> {
  const items: T[] = [];
  let cursor: string | undefined;
  for (let page = 0; page < maxPages; page += 1) {
    const result = await fetchPage(cursor);
    items.push(...result.items);
    cursor = result.next_cursor;
    if (cursor === undefined) return { items, complete: true };
  }
  return { items, complete: false };
}
